<template>
  <form-item-label label="性別" :required="true" />
  <complemented-text-form
    v-if="complementedTextOpened"
    :text="complementedText"
    @open="openForm"
    :editable="true"
    :colspan="1"
  />
  <td v-if="!complementedTextOpened">
    <div class="m3p-contact__input m3p-contact__sex">
      <div class="m3p-form-item__contact">
        <ul class="m3p-form-radio">
          <radio-form
            :name="fieldName"
            :selectableItems="selectiveSexList"
            :validator="validator"
            :dispatcher="dispatcher"
          />
        </ul>
        <error-message :name="fieldName" />
      </div>
    </div>
  </td>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import RadioForm from '@component_path/pages/common/form/element/radio';
import { useSexField } from '@component_path/inquiry_form_common_module/custom_hook/Sex';

const store = useStore();

const props = defineProps({
  defaultSex: {
    type: Number,
    required: false,
    default: 2
  }
});

const { fieldName, validator } = useSexField(true);
const dispatcher = ref('positionInquiryMail/setSex');

const complementedTextOpened = ref(false);
const selectiveSexList = ref([
  { code: 1, text: '男性' },
  { code: 2, text: '女性' }
]);

const sex = computed(() => store.state.positionInquiryMail.formData.sex);
const complementedText = computed(() => {
  if (sex.value === null) {
    return '';
  }
  const selectedSex = selectiveSexList.value.find(
    item => item.code === sex.value
  );
  return selectedSex ? selectedSex.text : '';
});

const openForm = () => (complementedTextOpened.value = false);

onMounted(() => {
  if (!!sex.value) {
    complementedTextOpened.value = true;
  } else {
    store.dispatch(dispatcher.value, props.defaultSex);
  }
});
</script>
